<template>
  <div class="page-main">
    <!--    <Back :backText="$t('Pick_your_level')" @goBackRoute="goBackRoute"></Back>-->
    <headerHsk
      :testType="computedTestType"
      :currentLevelIndex="computedLevelIndex"
      :currencyList="currencyList"
      :appLevelName="appLevelName"
      :priceObj="hskList[0]"
      @goAbout="goAbout"
      @show-page-paper="showPagePaper"
      @clickFreePractice="clickFreePractice"
      @goLearnResource="goLearnResource"
      @buyCodes="toBuyCodes"
    ></headerHsk>
    <div v-if="isPagePaperVisible == 'practice'" class="hsk-tittle">
      {{ $t('Take_practice_test') }}
    </div>

    <div
      class="container_price"
      v-if="hskList[0]?.product_currency && isPagePaperVisible == 'practice'"
    >
      <div class="container_price_num">
        {{ hskList[0]?.currency_symbol }}{{ hskList[0]?.product_price / hskList[0]?.currency_base }}
      </div>
      <div class="container_price_unit">
        &ensp;&ensp;{{ changeCurrency(hskList[0]?.product_currency.toUpperCase()) }}/
        {{ $t('test_session') }}
      </div>
      <div
        class="container_price_discount"
        v-if="
          !$store.state.user.isCodeUser &&
          hskList[0]?.product_currency !== 'INR' &&
          hskList[0]?.product_currency !== 'RUB'
        "
        @click="toBuyCodes"
      >
        {{ $t('get_a_discount') }}
      </div>
    </div>
    <DownLoadPaperList v-if="isShowDownload" :resourceList="resourceList"></DownLoadPaperList>
    <div v-else-if="isPagePaperVisible == 'practice'" class="page-paper">
      <div
        v-for="(item, index) in hskList"
        :key="index"
        :class="['paper-item', isAdminOrEdit ? `horn-${item.status}` : '']"
      >
        <div class="paper-item-top" :class="{ 'paper-item-top-100': item.percentage == 100 }">
          <div class="paper-item-top-left">
            <p>{{ item.nameTrans[computedLanguage] }}</p>
            <div class="small-list">
              <template v-if="item.answer">
                <div
                  class="small-item"
                  v-for="(i, id) in smallItem"
                  :key="id"
                  v-show="item.answer[`${i.icon}_paper_score`]"
                >
                  <SvgIcon :type="i.icon" class="icon"></SvgIcon>
                  <div>
                    {{
                      i.icon == 'writing' && item.mark_status != 2
                        ? '--'
                        : parseInt(
                            (item.answer[`${i.icon}_score`] /
                              item.answer[`${i.icon}_paper_score`]) *
                              100
                          )
                    }}%
                  </div>
                </div>
              </template>
              <div v-else class="paper_message">
                <div>{{ $t('test_total_question', { count: item.question_count }) }}</div>
                <div class="line"></div>
                <div style="padding-top: 1px">{{ `${item.timeFull} min` }}</div>
              </div>
            </div>
          </div>
          <div
            v-show="item.emulatePaperStatus === 1"
            :class="[item.percentage >= 60 ? 'score-green' : 'score-red']"
          >
            <el-progress
              v-if="item.mark_status == 2"
              type="circle"
              :percentage="item.percentage"
              :width="44"
              :color="item.percentage >= 60 ? '#62C1A5' : '#FF858C'"
              :stroke-width="3"
              :format="formatProgress"
            ></el-progress>
            <div v-else class="mark_img" :title="$t('mark_correct_ing')"></div>
          </div>
        </div>
        <div class="paper-item-bottom" style="justify-content: flex-end">
          <!--<div class="diamond" v-if="!isFree"> -->
          <!-- <SvgIcon type="diamond" class="icon"></SvgIcon>
            <div>{{ item.status == 0 ? "-" : item.credit }}</div> -->
          <!-- <div v-if="item.product_currency">
              <span>{{ item.product_currency.toUpperCase() }}</span
              >&nbsp;&nbsp;{{ item.product_price / item.currency_base }}
            </div> -->
          <!--</div> -->
          <div class="paper-status">
            <!-- 用于权限 发布 下架 启用 -->
            <div v-show="isAdminOrEdit && freeStatus !== 'assigned' && isLogin">
              <div
                :class="[
                  localLanguage !== 'cn' ? 'smallSize' : '',
                  compactStyle ? 'compact_button' : '',
                ]"
                v-if="item.status == 0"
                class="button button-status yellow"
                @click="clickPaperStatus(item.status, item.name, item.paperId, item)"
              >
                {{ $t('test_release') }}
              </div>
              <div
                :class="[
                  localLanguage !== 'cn' ? 'smallSize' : '',
                  compactStyle ? 'compact_button' : '',
                ]"
                v-else-if="item.status == 1"
                class="button button-status gray"
                @click="clickPaperStatus(item.status, item.name, item.paperId)"
              >
                {{ $t('test_off_shelf') }}
              </div>
              <div
                v-else-if="item.status == 2"
                :class="[
                  localLanguage !== 'cn' ? 'smallSize' : '',
                  compactStyle ? 'compact_button' : '',
                ]"
                class="button button-status gray"
                @click="clickPaperStatus(item.status, item.name, item.paperId)"
              >
                {{ $t('test_enable') }}
              </div>
            </div>
            <!-- 使用兑换码按钮  v-if="$store.state.user.isCodeUser"-->
            <div
              class="button button-code"
              :class="[
                localLanguage !== 'cn' ? 'smallSize' : '',
                compactStyle ? 'compact_button' : '',
              ]"
              @click="openCodeDialog(item)"
              v-if="
                item.assignment_public_status !== 'draft' &&
                item.emulatePaperStatus == null &&
                !item.credit_enough
              "
            >
              {{ $t('use_code') }}
            </div>
            <div
              v-if="!isBuy(item)"
              :class="[
                'button',
                localLanguage !== 'cn' ? 'smallSize' : '',
                compactStyle ? 'compact_button' : '',
                item.emulatePaperStatus === 0
                  ? 'button-blue'
                  : item.emulatePaperStatus === null && (item.credit_enough || isFree)
                  ? 'yellow'
                  : '',
                item.assignment_public_status === 'draft' ||
                (item.assignment_public_status === 'due' &&
                  !item.allow_delay &&
                  ['not_started', 'started'].includes(item.assignment_status))
                  ? 'disable'
                  : '',
              ]"
              :style="{ opacity: item.mark_status == 1 ? '0.6' : '' }"
              @click="jumpToDetails(item)"
            >
              {{ showBottonText(item) }}
            </div>
            <time class="start-time" v-if="item.assignment_public_status === 'draft'">{{
              item.plan_send_time
            }}</time>
          </div>
        </div>
      </div>
    </div>
    <!--    等级介绍模块-->
    <div class="tabs_box" v-else-if="isPagePaperVisible == 'introduce'">
      <el-tabs v-model="activeNameIntroduce" @tab-click="handleClick">
        <el-tab-pane :name="item.name" v-for="(item, index) in tabArrIntroduce" :key="index">
          <div slot="label" class="tabs_label_item">
            <SvgIcon
              :type="activeNameIntroduce === item.name ? item.selcted : item.name"
              class="icon-24"
            ></SvgIcon>
            <span
              :class="['tabs_label_text', activeNameIntroduce === item.name ? 'selected_text' : '']"
              >{{ labelName(item.label) }}</span
            >
          </div>
          <component
            :is="activeNameIntroduce"
            :level_contents="level_contents"
            :segments="segments"
          ></component>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="tabs_box" v-else-if="isPagePaperVisible == 'vocabulary'">
      <el-tabs v-model="activeNameVocabulary" @tab-click="handleClick">
        <el-tab-pane :name="item.name" v-for="(item, index) in tabArrVocabulary" :key="index">
          <div slot="label" class="tabs_label_item">
            <SvgIcon
              :type="activeNameVocabulary === item.name ? item.selcted : item.name"
              class="icon-24"
            ></SvgIcon>
            <span
              :class="[
                'tabs_label_text',
                activeNameVocabulary === item.name ? 'selected_text' : '',
              ]"
              >{{ labelName(item.label) }}</span
            >
          </div>
          <component
            :is="activeNameVocabulary"
            :level_contents="level_contents"
            :segments="segments"
          ></component>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      class="practice-root"
      :visible="freePracticeDialogVisible"
      :width="isMobile ? '90%' : '1024px'"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <FreePractice
        v-if="freePracticeDialogVisible"
        @closeDialog="freePracticeDialogVisible = false"
      ></FreePractice>
    </el-dialog>
    <el-dialog :visible.sync="dialogRecordVisible" top="20vh" width="900px" destroy-on-close>
      <div class="dialog-header">
        <div class="dialog-header-title">{{ $t('test_record') }}</div>
      </div>
      <div class="dialog-body">
        <!-- <div id="chartLine" class="chart-line"></div> -->
        <div class="table-content" v-if="tableData.length">
          <el-table :data="tableData" :header-cell-style="discountHeaderStyle" style="width: 100%">
            <el-table-column :label="$t('test_finish_time')" width="180">
              <template slot-scope="scope">
                {{ getTime(scope.row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column prop="paper_name" :label="$t('test_paper')" width="180">
            </el-table-column>
            <el-table-column prop="total_score">
              <div slot="header" class="header-content">
                <div>{{ $t('total_score') }}</div>
                <div class="number">{{ levelTotalScore }}</div>
              </div>
            </el-table-column>
            <el-table-column prop="listening_score">
              <div slot="header" class="header-content">
                <div>{{ $t('hsk_listen_name') }}</div>
                <div class="number">{{ levelListenScore }}</div>
              </div>
            </el-table-column>
            <el-table-column prop="reading_score">
              <div slot="header" class="header-content">
                <div>{{ $t('hsk_read_name') }}</div>
                <div class="number">{{ levelReadScore }}</div>
              </div>
            </el-table-column>
            <el-table-column prop="writing_score" v-if="tableData[0].writing_paper_score">
              <div slot="header" class="header-content">
                <div>{{ $t('hsk_write_name') }}</div>
                <div class="number">{{ levelWriteScore || '--' }}</div>
              </div>
            </el-table-column>
            <el-table-column width="90">
              <div slot-scope="scope">
                <div class="see_result">
                  <div @click="jumpReport(scope.row)">{{ $t('hsk_practice_check') }}</div>
                  <SvgIcon type="arrow-right" class="icon-18"></SvgIcon>
                </div>
              </div>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage1"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="tableTotal"
          >
          </el-pagination>
        </div>
        <empty-content v-else :loading="false" class="empty-content" />
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogPaperStatus"
      top="20vh"
      width="432px"
      custom-class="dialog-paper-status"
      :show-close="false"
    >
      <div class="paper-title" v-if="currentSelectPaperStatusId == 2">
        {{ $t('test_confirm_use') }}
      </div>
      <div class="paper-title" v-else-if="currentSelectPaperStatusId == 1">
        {{ $t('test_confirm_off_shelf') }}
      </div>
      <div class="paper-name">{{ currentSelectPaperName }}</div>
      <div class="paper-content">
        <div
          :class="[
            'diamond-input',
            currentSelectPaperStatusId == 0 || currentSelectPaperStatusId == 2
              ? ''
              : 'hidden-paper',
          ]"
        >
          <!-- <SvgIcon type="diamond" class="icon-18 diamond"></SvgIcon>
          <el-input
            v-model="diamondNumbers"
            oninput="value=value.replace(/[^\d]/g,'')"
            maxLength="3"
            placeholder=""
            @blur="diamondNumbers = $event.target.value"
          ></el-input> -->
        </div>
        <div class="button-tools">
          <button class="btn-default btn-status" @click="paperCancel()">
            {{ $t('button_common_cancel') }}
          </button>
          <button
            v-if="currentSelectPaperStatusId == 0"
            class="btn-yellow btn-status"
            @click="paperAction(1)"
          >
            {{ $t('test_release') }}
          </button>
          <button
            v-else-if="currentSelectPaperStatusId == 2"
            class="btn-yellow btn-status"
            @click="paperAction(1)"
            :disabled="diamondNumbers === ''"
          >
            {{ $t('test_enable') }}
          </button>
          <button
            v-else-if="currentSelectPaperStatusId == 1"
            class="btn-red btn-status"
            @click="paperAction(2)"
          >
            {{ $t('test_off_shelf') }}
          </button>
        </div>
      </div>
    </el-dialog>
    <!-- 支付回调弹框 -->
    <el-dialog
      :visible.sync="dialogPayCb"
      top="30vh"
      width="445px"
      center
      custom-class="pay-body"
      @close="closePay"
    >
      <div class="pay-loading">
        <img src="@/assets/images/loading.png" alt="" width="60" height="60" />
        <div class="pay-tips">{{ $t('waiting_pay') }}</div>
      </div>
      <div class="un_pay_tips">
        <div class="flex" :style="{ flexDirection: compactStyle ? 'column' : 'row' }">
          {{ $t('pay_failed') }}
          <p @click="linkPay()">{{ $t('common_text_server_error') }}</p>
        </div>
        <div class="flex m-t-10" :style="{ flexDirection: compactStyle ? 'column' : 'row' }">
          {{ $t('pay_un_finished') }}
          <p class="contact-us" @click="contactUs()">{{ $t('feedback') }}</p>
        </div>
        <div class="m-t-10">
          <p class="callback-tips">{{ $t('pay_tip') }}</p>
        </div>
      </div>
    </el-dialog>
    <!-- 选择货币种类 -->
    <el-dialog
      width="380px"
      top="30vh"
      :visible.sync="dialogCurrency"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="currency-body"
    >
      <div class="content">
        <p class="select-tips">{{ $t('select_currency_tips') }}:</p>
        <div class="select">
          <span class="title">{{ $t('currency') }}</span>
          <el-select v-model="currentCurrency">
            <el-option
              v-for="(item, index) in currencyList"
              :key="index"
              :label="item.description"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="change-currency-tips">{{ $t('change_currency_tips') }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="warning" @click="setPersonalInfo">{{ $t('cancel_confirm') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      width="95%"
      :show-close="false"
      :visible.sync="dialogNeedApp"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="practice-root"
    >
      <NeedDownload @close-modal="dialogNeedApp = false" />
    </el-dialog>

    <use-code ref="useCode" @onOk="onOk" :nameTrans="nameTrans"></use-code>
    <DiscountDialog ref="discount" @onClickBuy="onClickBuyCodes"></DiscountDialog>
    <CodesShowDialog ref="showCodes"></CodesShowDialog>
  </div>
</template>

<script>
import { mixinDownload, mixinMixpanel } from '@/mixins'
import {
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Table,
  TableColumn,
  Progress,
  Pagination,
} from 'element-ui'
import SvgIcon from '@/components/SvgIcon.vue'
import headerHsk from './components/header'
import Description from './components/description'
import Test from './components/testFormat'
import Vocabulary from './components/vocabulary'
import FreePractice from './components/freePractice'
import DownLoadPaperList from './components/downLoadPaperList'
// import testHeader from "@/components/hsk/common/testHeader.vue";
import echarts from 'echarts'
import { apiRequest } from '@/serves/http'
import { mapState, mapGetters, mapActions } from 'vuex'
import analytics from '@/utils/AnalyticsCenter'
import ApiPath from '@/serves/path'
import { IS_CHINA, pathUrl } from '@/config'
import UseCode from '@/components/useCode/index.vue'
import DiscountDialog from '@/components/useCode/DiscountDialog.vue'
import CodesShowDialog from '@/components/useCode/CodesShowDialog.vue'
import Back from '@/components/common/Back.vue'
import { getToken } from '@/utils/cache'
import { mixinLanguage } from '@/mixins'
import { showDownloadTypeList, getTestType } from '@/utils/hskTool'
import NeedDownload from './components/need-download-app.vue'

const controller = new AbortController()

export default {
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Progress.name]: Progress,
    [Pagination.name]: Pagination,
    SvgIcon,
    // testHeader,
    headerHsk,
    DownLoadPaperList,
    UseCode,
    Back,
    DiscountDialog,
    CodesShowDialog,
    Description,
    Test,
    Vocabulary,
    FreePractice,
    NeedDownload,
  },
  mixins: [mixinDownload, mixinMixpanel, mixinLanguage],
  data() {
    return {
      currentType: 0,
      currentLevelList: [],
      currentQuestionsObj: {},
      // currentLevelIndex: 0,
      // testType: 1,
      currentPaperList: [],
      currentHSKType: '',
      upgradeResourceList: [],
      upgradeDataList: [],
      dialogPracticeTableVisible: false,
      gridData: [],
      bigIndex: 0,
      nameTrans: {},
      smallItem: [
        {
          icon: 'listening',
        },
        {
          icon: 'reading',
        },
        {
          icon: 'writing',
        },
      ],
      pageSize: 5,
      dialogRecordVisible: false,
      tableData: [],
      chartData: [],
      tableTotal: 0,
      currentPage1: 1,
      paperStatusDesc: [''],
      // 考试次数
      testCount: 0,
      // 考试平均分
      testAverage: 0,
      // 最高分
      testMax: 0,
      // 最低分
      testMin: 0,
      // 当前选择试卷钻石数量
      currentTestCredit: 0,
      // 当前选择试卷的名字
      currentSelectPaperName: '',
      // 当前选择试卷的状态id
      currentSelectPaperStatusId: '',
      // 当前选择的paperId
      currentSelectPaperId: '',
      // 当前级别卷子总分
      levelTotalScore: 0,
      // 当前级别卷子听力总分
      levelListenScore: 0,
      // 当前级别卷子阅读总分
      levelReadScore: 0,
      // 当前级别卷子书写总分
      levelWriteScore: 0,
      // 卷子状态弹框
      dialogPaperStatus: false,
      // 发布卷子需要的钻石数量
      diamondNumbers: 0,
      // 支付回调弹框
      dialogPayCb: false,
      // 轮询查询余额定时器
      searchResultObj: null,
      // 当前支付链接
      payLink: '',
      // 选择货币弹窗
      dialogCurrency: false,
      // 货币列表：
      currencyList: [],
      resourceList: [],
      currentCurrency: '',
      // hskk展示用
      appLevelName: '',
      orderId: '',
      // 试卷等级
      level: 'hsk1',
      isShowDownload: false,
      isPagePaperVisible: 'practice',
      activeNameIntroduce: 'Description',
      activeNameVocabulary: 'Vocabulary',
      tabArrIntroduce: [
        {
          name: 'Description',
          selcted: 'Descriptioned',
          label: 'Description',
          icon: '',
        },
        {
          name: 'Test',
          selcted: 'Tested',
          label: 'Test_format',
        },
      ],
      tabArrVocabulary: [
        {
          name: 'Vocabulary',
          selcted: 'Vocabularyed',
          label: 'Vocabulary',
        },
      ],
      level_contents: [], //description
      segments: [], //test format
      routeTypeName: '',
      freePracticeDialogVisible: false,

      isMobile: false,

      dialogNeedApp: false,
    }
  },
  created() {
    if (IS_CHINA) {
      if (this.hasSetCurrency) this.setPersonalInfo()
    } else {
      if (this.hasSetCurrency) this.selectCurrencyType()
    }
    const path = window.location.pathname || this.$route.path
    this.level = this.$route.query.level
    if (this.$route.query.level_num) {
      if (path.toLowerCase().includes('hskk')) {
        this.level = `hskk${this.$route.query.level_num}`
      } else {
        this.level = path.toLowerCase().includes('hsk')
          ? `hsk${this.$route.query.level_num}`
          : `yct${this.$route.query.level_num}`
      }

      let url = `${window.location.origin}${window.location.pathname}`
      let searchStr = ''
      if (window.location.search) {
        let searchArr = window.location.search.replace('?', '').split('&')

        searchArr.forEach((item, index) => {
          if (item.indexOf('level_num') > -1) {
            searchArr[index] = 'level=' + this.level
          }
          let sy = index == 0 ? '?' : '&'
          searchStr = searchStr + sy + searchArr[index]
        })
      }
      window.history.replaceState({}, '', url + searchStr)
    }

    // window.history.replaceState({}, '', url)
    // this.level = path.toLowerCase().includes('hsk')
    //   ? `hsk${this.computedLevelIndex}`
    //   : `yct${this.computedLevelIndex}`
    //模拟考页埋点
    let mixpanelParams = {
      // people_id: this.peopleId,
      // unlimited: this.unlimited,
      exam_type: this.typeName.level_name,
    }
    analytics.logEvent('hskweb_paperindex_view', mixpanelParams)
    this.selectCurrencyType(false)
  },
  computed: {
    computedName() {
      return this.$t('hsk_end_preview')
    },
    ...mapState({
      role: (state) => state.user.role,
      levelList: (state) => state.level.levelList,
      levelActive: (state) => state.level.levelActive,
      levelType: (state) => state.level.levelType,
      levelActiveIndex: (state) => state.level.levelActiveIndex,
      isFree: (state) => state.user.isFree,
      freeStatus: (state) => state.user.freeStatus,
      hasSetCurrency: (state) => state.user.not_set_currency,
      currency: (state) => state.user.currency,
      givenName: (state) => state.user.given_name,
      familyName: (state) => state.user.family_name,
      gender: (state) => state.user.gender,
      countryName: (state) => state.user.country_name,
      isLogin: (state) => state.user.login,
    }),
    ...mapGetters('level', {
      // 获取考试类型
      typeName: 'levelActiveObj',
      levelTypeName: 'levelTypeName',
    }),
    hskList: {
      get() {
        return this.currentLevelList
      },
    },
    showVipImg() {
      return function (item) {
        return item.resource_status == 1
      }
    },
    introduceList() {
      return [this.$t('test_has_on_shelf'), this.$t('test_un_release'), this.$t('test_un_enable')]
    },
    isAdminOrEdit() {
      return this.role === 'admin' || this.role === 'editor'
    },
    // 计算统计数组
    computedTotalList() {
      return [
        {
          name: this.$t('test_max_score'),
          score: this.testMax,
        },
        {
          name: this.$t('test_average_score'),
          score: this.testAverage,
        },
        {
          name: this.$t('test_min_score'),
          score: this.testMin,
        },
      ]
    },
    computedLevelId() {
      return Number(this.levelActive || localStorage.getItem('LevelActive'))
    },
    computedTestType() {
      // level
      let level_type = this.getLevelTypeByRoute()
      return Number(level_type || this.levelType || localStorage.getItem('LevelType'))
    },
    computedLevelIndex() {
      return Number(
        this.getLevelIndex(this.levelIdQuery) ||
          this.getLevelIndex(this.computedParamsLevelId) ||
          this.levelActiveIndex ||
          localStorage.getItem('LevelActiveId')
      )
    },
    computedParamsLevelId() {
      let level_num = 1
      if (this.$route.query.level && this.$route.query.level.match(/\d+/)) {
        level_num = +this.$route.query.level.match(/\d+/)[0]
      } else if (this.$route.query.level_num) {
        level_num = this.$route.query.level_num
      }
      let level_type = this.getLevelTypeByRoute()
      let levelList = this.levelList.find((item) => item.level_type == level_type)
      // 此处7-9不生效；
      return levelList?.levels.find((item) => level_num == item.level_id)?.id || null
    },
    computedItemList() {
      let itemList = [
        {
          name: this.$t('test_all'),
          val: 'total',
          color: '#FF858C',
        },
        {
          name: this.$t('hsk_listen_name'),
          val: 'listening',
          color: '#FAC856',
        },
        {
          name: this.$t('hsk_read_name'),
          val: 'reading',
          color: '#62C1A5',
        },
      ]
      if (this.chartData.length > 0 && this.chartData[0].writing_paper_score) {
        itemList.push({
          name: this.$t('hsk_write_name'),
          val: 'writing',
          color: '#6AB9D2',
        })
      }
      return itemList
    },
    // 计算当前语言
    computedLanguage() {
      return localStorage.getItem('language') || 'zh'
    },
    isLearner() {
      return this.$store.state.user.role === 'learner'
    },
    // 越南地区不显示购买按钮
    isBuy() {
      return (item) => {
        return (
          item.emulatePaperStatus == null &&
          !item.credit_enough &&
          (this.$store.state.user.isCodeUser || this.currency == 'INR' || this.currency == 'RUB')
          // ||this.currency == 'VND'
        )
      }
    },
    levelIdQuery() {
      let level_id = this.$route.query.level_id || null
      return level_id
    },
    isChina() {
      return IS_CHINA
    },
    compactStyle() {
      let local = localStorage.getItem('language')
      console.log(local, 'loacallllllllllllllll')
      if (local == 'mn' || local == 'fr') {
        return true
      }
      return false
    },
  },
  watch: {
    computedLevelId: {
      handler(val) {
        if (val !== null) this.getIntroduce()
      },
      deep: true,
      immediate: true,
    },
    levelActive: {
      handler(current) {
        // console.log(current)
        if (this.$route.query.level) {
          this.level = this.$route.query.level
        }
        if (this.$route.query.level_num) {
          const path = window.location.pathname || this.$route.path
          if (path.toLowerCase().includes('hskk')) {
            this.level = `hskk${this.$route.query.level_num}`
          } else {
            this.level = path.toLowerCase().includes('hsk')
              ? `hsk${this.$route.query.level_num}`
              : `yct${this.$route.query.level_num}`
          }
        }
        this.isShowDownload = showDownloadTypeList.some((item) => item === this.level)
        if (this.isShowDownload) {
          this.getPaperResource()
        } else {
          this.getPaperList()
        }
        this.getMockStatistics()
      },
      immediate: true,
    },
    dialogPayCb: {
      handler(val) {
        if (!val) {
          this.searchResultObj && clearInterval(this.searchResultObj)
        }
      },
    },
    computedParamsLevelId: {
      async handler(val) {
        console.log(val, 'vallllllllllllllllllllllllllllll')
        if (val) {
          let path = window.location.href || this.$route.path
          if (
            path?.includes('level_id') ||
            path?.includes('level_num') ||
            path?.includes('level')
          ) {
            console.log(this.computedTestType, ' this.computedTestType')
            console.log(this.computedParamsLevelId, 'levelId: this.computedParamsLevelId,')
            console.log(this.computedLevelIndex, 'this.computedLevelIndex,this.computedLevelIndex,')
            await this.$store.dispatch('level/changeLevel', {
              levelType: this.computedTestType,
              levelId: this.computedParamsLevelId,
              levelIndex: this.computedLevelIndex,
            })
          }
          if (!this.isLogin && val) {
            console.log(console.log('erci diaoyong '))
            this.getPaperResource()
          }
        }
      },
      immediate: true,
    },
  },
  filters: {
    filterPaperName: function (nameTrans) {
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }

      return nameTrans[language]
    },
  },
  methods: {
    // 价格
    changeCurrency(product_currency) {
      console.log('ppppppppp', product_currency, this.currencyList)
      for (let i = 0; i < this.currencyList.length; i++) {
        if (this.currencyList[i].code === product_currency) {
          return this.currencyList[i].description.replace(product_currency, '').trim()
        }
      }
    },
    // 获取介绍信息
    getIntroduce() {
      window.utilV2.getData(
        window.ApiPath.get_level_detail_new,
        { level_id: this.computedLevelId },
        (data) => {
          console.log('接口返回', data)
          this.level_contents = [data.level_contents[0], data.level_contents[2]]
          this.segments = data
          this.appLevelName = data?.app_level_name
            ? JSON.parse(data?.app_level_name)[this.localLanguage]
            : ''
          console.log('segments', this.segments)
          analytics.logEvent('hskweb_abtlevel_view', {
            exam_type: this.segments.level_name,
          })
        },
        null,
        {
          authorization: true,
          showLoading: false,
        }
      )
    },
    labelName(label) {
      return this.$t(label)
    },
    clickFreePractice() {
      if (this.isMobile) {
        this.dialogNeedApp = true
        return
      }
      this.freePracticeDialogVisible = true
    },
    goLearnResource() {
      let mixpanelParams = {
        exam_type: this.segments.level_name,
      }
      analytics.logEvent('hskweb_abtlevelresource_click', mixpanelParams)
      window.open(pathUrl.WOHUI)
    },
    handleClick() {
      console.log('切换=', this.activeNameVocabulary)
      let mixpanelParams = {
        exam_type: this.segments.level_name,
        type: this.activeName == 'Test' ? 'Test format' : this.activeName,
      }
      analytics.logEvent('hskweb_abtlevelswitch_click', mixpanelParams)
    },
    showPagePaper(pageName) {
      if (this.isMobile && pageName === 'vocabulary') {
        this.dialogNeedApp = true
        return
      }

      this.isPagePaperVisible = pageName
      console.log('✅ showPagePaper triggered')
    },
    getLevelTypeNameByRoute() {
      let path = window.location.pathname || this.$route.path
      return path.split('/')[1]
    },
    getLevelTypeByRoute() {
      let typestr = this.getLevelTypeNameByRoute()
      return getTestType(typestr)
    },
    getLevelIndex(level_num) {
      let levels = this.levelList.map((item) => item.levels)
      const mergedArr = [].concat(...levels)
      return mergedArr?.find((item) => level_num == item.id)?.level_id || null
    },
    goBackRoute() {
      const params = {
        exam_type: this.levelTypeName + this.levelActiveIndex,
      }
      analytics.logEvent('hskweb_switch_click', params)
      this.$router.replace({
        name: 'ChooseLevel',
      })
    },
    onOk() {
      this.getPaperList()
    },
    ...mapActions({
      checkIsFreeTest: 'user/checkIsFreeTest',
      refreshUser: 'user/refreshUser',
    }),
    goAbout() {
      let mixpanelParams = {
        exam_type: this.typeName.level_name,
      }
      analytics.logEvent('hskweb_abtlevel_click', mixpanelParams)
      console.log('levelTypeName Index', this.levelTypeName, this.levelActiveIndex)

      this.$router.push({
        path: '/' + this.getLevelTypeNameByRoute() + '/about',
        query:
          this.freeStatus === 'assigned' && this.isLearner
            ? {
                paperId: this.currentQuestionsObj.paperIdStr,
                examinationType: 4,
                level: this.level,
              }
            : {
                paperId: this.currentQuestionsObj.paperIdStr,
                examinationType: 2,
                level: this.level,
              },
      })
    },
    selectCurrencyType(data = true) {
      if (data) this.dialogCurrency = true
      // 获取货币种类列表
      apiRequest.get(ApiPath.getCurrencyList).then((res) => {
        this.currencyList = res?.data?.map((item) => {
          return {
            ...item,
            description:
              JSON.parse(item.description)?.[localStorage.getItem('language')] ??
              JSON.parse(item.description)?.['zh'],
          }
        })
        this.currentCurrency = this.currency
      })
    },
    setPersonalInfo() {
      const params = {
        given_name: this.givenName,
        family_name: this.familyName,
        gender: this.gender,
        country_name: this.countryName,
        currency: IS_CHINA ? 'CNY' : this.currentCurrency,
      }
      apiRequest
        .post(ApiPath.change_userInfo, params)
        .then((res) => {
          console.log(res)
          this.dialogCurrency = false
          !IS_CHINA &&
            this.$message({
              message: this.$t('change_info_success'),
              type: 'success',
            })
          this.refreshUser()
        })
        .catch(() => {
          !IS_CHINA && this.$message.error(this.$t('change_info_fail'))
        })
    },
    // 隐藏掉不需要的表头
    discountHeaderStyle({ rowIndex }) {
      if (rowIndex == 1) {
        return { display: 'none' }
      } else {
        return { background: '#FAFAFB', border: 'none', fontSize: '12px', color: '#B5B5BE' }
      }
    },
    getTime(time) {
      return this.$dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    jumpReport(item) {
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }
      let params = {
        paperId: item.paperIdStr,
        paperStatus: item.paperStatus,
        name:
          typeof item.nameTrans == 'string'
            ? JSON.parse(item.nameTrans)[language]
            : item.nameTrans[language],
        examinationType: this.freeStatus === 'assigned' && this.isLearner ? 4 : 2,
        resource_status: item.resource_status,
        level: this.level,
      }
      if (item.answer?.id) {
        Object.assign(params, { examination_id: item.answer?.id })
      }
      let newUrl = this.$router.resolve({
        name: 'ResultReport',
        query: params,
      })
      window.open(newUrl.href, '_blank')
    },
    async jumpToDetails(item) {
      // 与按钮展示文案逻辑对应
      if (item.assignment_public_status) {
        switch (item.assignment_public_status) {
          case 'draft':
            return
          case 'due':
            if (!item.allow_delay) {
              // 不允许延迟
              if (['not_started', 'started'].includes(item.assignment_status)) {
                return
              } else {
                this.jumpReport(item)
              }
            }
        }
      }
      let examType = ''
      if (item.emulatePaperStatus !== 1) {
        //hskweb_start1_click埋点
        if (item.emulatePaperStatus === 0) {
          examType = 'continue'
        } else {
          if (this.isFree || item.credit_enough || this.freeStatus == 'assigned') {
            examType = 'strat'
          } else {
            examType = 'buy'
          }
        }
        if (examType !== 'buy') {
          let mixpanelParams = {
            // people_id: this.peopleId,
            // unlimited: this.unlimited,
            paper_type: this.$options.filters['filterPaperName'](item.nameTrans),
            exam_type: item.levelName,
            type: examType,
          }
          analytics.logEvent('hskweb_start1_click', mixpanelParams)
        }
      }
      if (item.resource_status == -1) {
        return window.layer.msg(this.$t('member_error'))
      }
      this.currentTestCredit = item.credit
      this.nameTrans = item.nameTrans
      if (item.emulatePaperStatus == 1) {
        this.jumpReport(item)
      } else {
        // 跳转支付
        if (!this.isFree) {
          let isEnough = await this.searchRechargeStatus(
            item.paperId,
            item.assignment_id ? item.assignment_id : null
          )
          if (!isEnough && item.emulatePaperStatus !== 0) {
            await this.onPurchase(item)
            if (this.isChina) {
              return
            }
          }
        }
        // 先下载资源数据
        this.currentQuestionsObj = item
        const rootPath = item.resourceUrl.slice(0, -4) + '/'
        console.log('支付 下载？', rootPath, item)
        // 显示下载进度用的
        this.downloadPluging.download({
          files: 'index.json',
          state: 'entry',
          root_path: rootPath,
        })
      }
    },
    /**
     * 进入支付流程
     * @param {*} item 支付订单id等信息
     * @param {*} isBuyCodes 是否是购买多个兑换码
     */
    async onPurchase(item, isBuyCodes) {
      if (IS_CHINA) {
        let language = localStorage.getItem('language')
        if (language === 'zh') {
          language = 'cn'
        }
        let paperStatus = {
          not_started: null,
          started: 0,
          submitted: 1,
          marked: 1,
        }
        const rootPath = item.resourceUrl ? item.resourceUrl.slice(0, -4) + '/' : null
        const data =
          this.freeStatus === 'assigned' && this.isLearner
            ? {
                paperId: item.paperIdStr,
                paperStatus: paperStatus[item?.assignment_status],
                name: item?.paper_name_trans ? item?.paper_name_trans[language] : '',
                examinationType: 4,
                mock_type: this.computedTestType,
                assignment_id: item.assignment_id,
                examination_id: item?.answer?.id,
              }
            : {
                paperId: item.paperIdStr,
                paperStatus: item.emulatePaperStatus,
                name: item.nameTrans ? item.nameTrans[language] : '',
                examinationType: 2,
                mock_type: this.computedTestType,
                status: item.status,
                product_id: item.product_id,
                examination_id: item?.answer?.id,
              }
        console.log('支付 跳转 国内', rootPath, data)
        this.$router.push({
          path: '/pay/index',
          query: {
            product_id: item?.product_id,
            root_path: rootPath,
            ...data,
            product_type: isBuyCodes ? 'codes' : 'test', // 类型 区分折扣价:codes、直接购买:test、购买作业:assignments
          },
        })
        return
      } else {
        console.log('支付的id', item.product_id)
        const { payment_link, order_id } = await this.getPayLink(item?.product_id)
        this.orderId = order_id
        // 购买兑换码的情况下，并没有点击购买按钮，而是从DiscountDialog触发
        if (!isBuyCodes) {
          let mixpanelParams = {
            paper_type: this.$options.filters['filterPaperName'](item.nameTrans),
            exam_type: item.levelName,
            type: 'buy',
            order_id: order_id,
          }
          analytics.logEvent('hskweb_start1_click', mixpanelParams)
        }

        this.payLink = payment_link
        window.open(payment_link)
        this.dialogPayCb = true
        await this.createSetInterval(order_id)
      }
    },
    async onClickBuyCodes(item) {
      this.$refs.discount.closeDialog()
      console.log('支付开始 ', item)
      if (!item) return
      await this.onPurchase(item, true)
      console.log('支付完成？？ 打开兑换码批量购买对话框', this.orderId)
      // 等收到结果之后 显示兑换码
      if (this.orderId && !this.isChina) {
        this.$refs.showCodes.openDialog(this.orderId)
      }
    },
    // 下载后的回调
    downloadCompleteCallback() {
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }
      let paperStatus = {
        not_started: null,
        started: 0,
        submitted: 1,
        marked: 1,
      }

      this.$router.push({
        name: 'Introduce',
        query:
          this.freeStatus === 'assigned' && this.isLearner
            ? {
                paperId: this.currentQuestionsObj.paperIdStr,
                paperStatus: paperStatus[this.currentQuestionsObj.assignment_status],
                name: this.currentQuestionsObj?.paper_name_trans?.[language] ?? '',
                examinationType: 4,
                mock_type: this.computedTestType,
                assignment_id: this.currentQuestionsObj.assignment_id,
                examination_id: this.currentQuestionsObj?.answer?.id,
                level: this.level,
              }
            : {
                paperId: this.currentQuestionsObj.paperIdStr,
                paperStatus: this.currentQuestionsObj.emulatePaperStatus,
                root_path: this.currentQuestionsObj.resourceUrl.slice(0, -4) + '/',
                name: this.currentQuestionsObj.nameTrans[language],
                examinationType: 2,
                // level: this.currentLevelIndex + 1,
                // nameTrans: JSON.stringify(this.nameTrans),
                mock_type: this.computedTestType,
                status: this.currentQuestionsObj.status,
                product_id: this.currentQuestionsObj.product_id,
                examination_id: this.currentQuestionsObj?.answer?.id,
                level: this.level,
              },
      })
    },
    // 获取试卷列表
    async getPaperList() {
      await this.checkIsFreeTest()
      window.utilV2.postData(
        this.freeStatus === 'assigned' && this.isLearner
          ? window.ApiPath.get_stu_assignment_paper_list
          : window.ApiPath.hsk_paper_list,
        // { level_id: this.computedLevelId, mock_type: this.computedTestType },
        { level_id: this.computedParamsLevelId || this.levelIdQuery || this.computedLevelId },
        (data) => {
          if (data.paperList && data.paperList.length > 0) {
            this.currentLevelList = data.paperList.map((item) => {
              let emulateStatus = {
                not_started: '',
                started: 0,
                submitted: 1,
                marked: 1,
              }
              let markStatus = {
                not_started: '',
                started: '',
                submitted: 0,
                marked: 2,
              }
              // emulatePaperStatus 全仿真模式试卷状态0: 未完成1: 已完成默认 空值: 未开始
              let params =
                this.freeStatus === 'assigned' && this.isLearner
                  ? {
                      ...item,
                      emulatePaperStatus: emulateStatus[item.assignment_status],
                      mark_status: markStatus[item.assignment_status],
                      nameTrans: JSON.parse(item.nameTrans),
                      percentage: parseInt((item.scoreTotal / item.scoreFull) * 100),
                    }
                  : {
                      ...item,
                      nameTrans: JSON.parse(item.nameTrans),
                      percentage: parseInt((item.emulateScoreTotal / item.scoreFull) * 100),
                    }
              return params
            })
            // 排序
            console.log(this.currentLevelList)
            this.currentLevelList = this.currentLevelList.sort((a, b) => a.seq - b.seq)
            console.log(this.currentLevelList)
          } else {
            this.currentLevelList = []
          }
        },
        null,
        {
          authorization: true,
        }
      )
    },
    getPaperResource() {
      // 未登录刷新页面时，获取到的level_id为接口请求返回的0；
      // 相同位置getPaperList存在同样bug，由于参数等待了一个check请求，导致level_id可获取路由正确值，但是localstorage中仍然存储错误值，此方法与其同步；
      // computedParamsLevelId--获取到路由level时请求此方法；
      window.utilV2.getData(
        window.ApiPath.hsk_paper_resource,
        { level_id: this.computedParamsLevelId || this.levelIdQuery || this.computedLevelId },
        (data) => {
          this.resourceList = data.mock_levels_resource_list
        },
        null,
        {
          authorization: true,
        }
      )
    },
    // 获取模拟考页面统计数据
    getMockStatistics() {
      window.utilV2.getData(
        window.ApiPath.hsk_mock_statistics,
        { level_id: this.levelIdQuery || this.computedLevelId },
        (data) => {
          this.testCount = data.count
          this.testAverage = data.average
          this.testMax = data.max
          this.testMin = data.min
        },
        null,
        {
          authorization: true,
        }
      )
    },
    // 计算完成状态
    paperStatus(status) {
      let finishStatus
      let _this = this
      switch (status) {
        case 0:
          finishStatus = _this.$t('hsk_not_finished')
          break
        case null:
          finishStatus = _this.$t('hsk_not_start')
          break
        case 1:
          finishStatus = _this.$t('hsk_finished')
          break
      }
      return finishStatus
    },
    // 绘制折线图
    renderChart() {
      // 重新拼装折线图数据
      console.log(this.chartData)
      let data = this.chartData.map((item) => {
        return {
          value: this.getTime(item.created_at),
          paperName: item.paper_name,
        }
      })
      let seriesList = this.computedItemList.map((item) => {
        return {
          name: item.name,
          type: 'line',
          stack: 'Total',
          color: item.color,
          data: this.chartData.map((t) => {
            return t[`${item.val}_paper_score`]
              ? `${(t[`${item.val}_score`] / t[`${item.val}_paper_score`]) * 100}`
              : 0
          }),
        }
      })
      let chartLine = echarts.init(document.getElementById('chartLine'))
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (a) {
            let title = data.find((item) => item.value == a[0].name)?.paperName
            let list = []
            let listItem = ''
            for (var i = 0; i < a.length; i++) {
              list.push(
                '<i style="display: inline-block;width: 10px;height: 10px;background: ' +
                  a[i].color +
                  ';margin-right: 5px;border-radius: 50%;}"></i><span style="width:70px; display:inline-block;">' +
                  a[i].seriesName +
                  ':</span> &nbsp&nbsp' +
                  parseInt(a[i].value) +
                  '%'
              )
            }
            listItem = list.join('<br>')
            return (
              '<div class="showBox">' +
              '<p>' +
              title +
              '</p>' +
              '<p>' +
              a[0].name +
              '</p>' +
              listItem +
              '</div>'
            )
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          splitLine: {
            show: false,
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置。
            formatter: function (params) {
              var newParamsName = '' // 最终拼接成的字符串
              var paramsNameNumber = params.length // 实际标签的个数
              var provideNumber = 10 // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = '' // 表示每一次截取的字符串
                  var start = p * provideNumber // 开始截取的位置
                  var end = start + provideNumber // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber)
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + '\n'
                  }
                  newParamsName += tempStr // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params
              }
              //将最终的字符串返回
              return newParamsName
            },
          },
          data,
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
          },
          show: false,
        },
        series: seriesList,
      }
      chartLine.resize()
      chartLine.setOption(option)
    },
    // 获取模拟考作答记录列表
    getMockResultList() {
      apiRequest
        .post(
          ApiPath.hsk_mock_result_list,
          {
            level_id: this.levelIdQuery || this.computedLevelId,
            limit: this.pageSize,
            page: this.currentPage1,
          },
          {
            loading: true,
          }
        )
        .then((res) => {
          if (res.data.records && res.data.records.length > 0) {
            let {
              total_paper_score,
              listening_paper_score,
              reading_paper_score,
              writing_paper_score,
            } = res.data.records[0]
            this.levelTotalScore = total_paper_score
            this.levelListenScore = listening_paper_score
            this.levelReadScore = reading_paper_score
            this.levelWriteScore = writing_paper_score
            this.tableData = res.data.records
            this.tableTotal = res.data.total_size
          }
        })
    },
    // 获取全部模拟考作答记录
    getAllMockResultList() {
      apiRequest
        .post(
          ApiPath.hsk_mock_result_list,
          {
            level_id: this.levelIdQuery || this.computedLevelId,
          },
          {
            loading: true,
          }
        )
        .then((res) => {
          if (res.data.records && res.data.records.length > 0) {
            this.chartData = res.data.records.reverse()
            // this.renderChart();
          }
        })
    },
    clickPaperStatus(id, name, paperId, item) {
      console.log(id, name, paperId, item, 'id, name, paperId')
      this.currentSelectPaperId = paperId
      this.currentSelectPaperName = name
      this.currentSelectPaperStatusId = id
      this.dialogPaperStatus = true
    },
    seeRecord() {
      this.dialogRecordVisible = true
      this.tableData = []
      this.chartData = []
      this.getAllMockResultList()
      this.getMockResultList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.currentPage1 = val
      this.getMockResultList()
      console.log(`当前页: ${val}`)
    },
    paperCancel() {
      this.dialogPaperStatus = false
    },
    // 不同卷子状态事件
    paperAction(status) {
      let params = {
        paper_id: this.currentSelectPaperId,
        status: status,
      }
      // if (this.currentSelectPaperStatusId == 0 || this.currentSelectPaperStatusId == 2) {
      //   params.credit = Number(this.diamondNumbers);
      // }
      apiRequest
        .post(window.ApiPath.hsk_edit_paper_status, params, {
          loading: true,
        })
        .then(() => {
          this.getPaperList()
          this.dialogPaperStatus = false
        })
    },
    // 复写progress 内容
    formatProgress(percentage) {
      return percentage || '0'
    },
    // 获取试卷支付连接
    getPayLink(product_id) {
      return new Promise((resolve, reject) => {
        apiRequest
          .post(
            window.ApiPath.stripe_create_order,
            {
              product_id: product_id,
            },
            {
              loading: true,
            }
          )
          .then((res) => {
            resolve(res?.data)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    // 查询订单库存
    searchRechargeStatus(paperId, assignment_id) {
      return new Promise((resolve) => {
        let params = { paper_id: paperId }
        if (assignment_id) {
          params.assignment_id = assignment_id
        }
        window.utilV2.getData(
          ApiPath.hsk_check_Credit,
          params,
          (data) => {
            resolve(data.enough)
          },
          () => {},
          {
            showLoading: true,
          }
        )
      })
    },
    createSetInterval(orderId) {
      return new Promise((resolve) => {
        let _this = this
        clearInterval(_this.searchResultObj)
        this.searchResultObj = setInterval(() => {
          window.utilV2.getData(
            ApiPath.pay_recharge_log,
            { order_id: orderId },
            (data) => {
              if (data.status) {
                _this.dialogPayCb = false
                console.log('支付成功了 取消轮询')
                resolve('success')
                clearInterval(_this.searchResultObj)
              }
            },
            () => {},
            {
              showLoading: false,
            }
          )
        }, 1000)
      })
    },
    linkPay() {
      //hskweb_payagain_click埋点
      let mixpanelParams = {
        people_id: this.peopleId,
        exam_type: this.typeName.level_name,
        paper_type: this.$options.filters['filterPaperName'](this.nameTrans),
        order_id: this.orderId,
      }
      analytics.logEvent('hskweb_payagain_click', mixpanelParams)
      window.open(this.payLink)
    },
    contactUs() {
      //hskweb_payagain_click埋点
      let mixpanelParams = {
        people_id: this.peopleId,
        exam_type: this.typeName.level_name,
        paper_type: this.$options.filters['filterPaperName'](this.nameTrans),
        order_id: this.orderId,
      }
      analytics.logEvent('hskweb_paycontact_click', mixpanelParams)
      this.$router.push('/feedback')
    },
    closePay() {
      //hskweb_payclose_click埋点
      let mixpanelParams = {
        people_id: this.peopleId,
        exam_type: this.typeName.level_name,
        paper_type: this.$options.filters['filterPaperName'](this.nameTrans),
        order_id: this.orderId,
      }
      analytics.logEvent('hskweb_payclose_click', mixpanelParams)
    },
    openCodeDialog(item) {
      // if (IS_CHINA) {
      //   return
      // }
      let mixpanelParams = {
        exam_type: this.typeName.level_name,
      }
      analytics.logEvent('hskweb_usecode_click', mixpanelParams)
      if (this.$store.state.user.login && getToken()) {
        this.$refs.useCode?.openDialog(item.paperId, item.levelId, item.nameTrans)
      } else {
        this.$store.dispatch('user/handleLogout', { reLogin: true })
      }
    },
    /** 打开兑换码批量购买对话框 */
    toBuyCodes() {
      this.$refs.discount.openDialog()
    },
    // 展示试卷按钮文案
    showBottonText(item) {
      console.log('展示试卷按钮文案', item)
      if (item.assignment_public_status) {
        // 作业列表
        switch (item.assignment_public_status) {
          // 未开始
          case 'draft':
            return this.$t('start_answer')
          // 已发布
          case 'published':
            if (item.emulatePaperStatus) {
              return this.$t('view_result')
            } else if (item.emulatePaperStatus === 0) {
              return this.$t('hsk_go_on')
            } else if (this.isFree || item.credit_enough || this.freeStatus == 'assigned') {
              return this.$t('start_answer')
            } else {
              return this.$t('hsk_buy')
            }
          // 已过期
          case 'due':
            // 允许延迟
            if (item.allow_delay) {
              if (item.emulatePaperStatus) {
                return this.$t('view_result')
              } else if (item.emulatePaperStatus === 0) {
                return this.$t('hsk_go_on')
              } else if (this.isFree || item.credit_enough || this.freeStatus == 'assigned') {
                return this.$t('start_answer')
              } else {
                return this.$t('hsk_buy')
              }
            } else {
              // 不允许延迟
              if (['not_started', 'started'].includes(item.assignment_status)) {
                return this.$t('deadline_passed')
              } else {
                return this.$t('view_result')
              }
            }
        }
      } else {
        // 试卷列表
        if (item.emulatePaperStatus) {
          return this.$t('view_result')
        } else if (item.emulatePaperStatus === 0) {
          return this.$t('hsk_go_on')
        } else if (this.isFree || item.credit_enough || this.freeStatus == 'assigned') {
          return this.$t('start_answer')
        } else {
          return this.$t('hsk_buy')
        }
      }
    },
  },
  destroyed() {
    clearInterval(this.searchResultObj)
  },

  mounted() {
    this.isMobile = window.innerWidth < 768
    window.addEventListener(
      'resize',
      () => {
        this.isMobile = window.innerWidth < 768
      },
      { signal: controller.signal }
    )
  },

  unMounted() {
    controller.abort()
  },
}
</script>

<style lang="scss" scoped>
.page-main {
  height: 100%;
  .page-statistics {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .statistics-item {
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      color: #696974;
      .score {
        margin-right: 32px;
      }
      .records {
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        text-align: right;
        color: #b5b5be;
      }
      ::v-deep .number {
        font-family: 'Inter';
        font-weight: 500;
        font-size: 24px;
        line-height: 20px;
        color: #faae56;
        margin-left: 2px;
        vertical-align: bottom;
      }
      .chart {
        width: 24px;
        height: 24px;
        margin-right: 14px;
      }
      .item-step {
        &:not(:last-child) {
          flex-basis: 50%;
        }
        &:last-child {
          flex-basis: auto !important;
          flex-shrink: 0;
          flex-grow: 0;
        }
        &_item {
          position: relative;
          width: 100%;
          .line {
            position: absolute;
            height: 1px;
            background: #b5b5be;
            left: 0;
            right: 0;
            top: 2px;
          }
          .spot {
            width: 5px;
            height: 5px;
            background: #b5b5be;
            border-radius: 50%;
          }
        }
        &_score {
          margin-bottom: 2px;
          color: #faae56;
          font-weight: 400;
          font-size: 18px;
          margin-left: -14px;
          .score-box {
            min-width: 33px;
            display: inline-block;
            text-align: center;
          }
        }
        &_text {
          margin-top: 5px;
          color: #696974;
          font-weight: 500;
          font-size: 12px;
          margin-left: -14px;
        }
      }
    }
    .item-center {
      position: absolute;
      left: 51%;
      transform: translateX(-50%);
    }
  }
  .page-paper {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    .paper-item {
      width: 382px;
      min-height: 133px;
      border: 1px solid #efeff1;
      border-radius: 12px;
      box-sizing: border-box;
      margin-bottom: 16px;
      background: #ffffff;
      cursor: pointer;
      &:not(:nth-child(3n)) {
        margin-right: 24px;
      }
      &-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 24px 15px 20px;
        ::v-deep .el-progress__text {
          font-size: 18px !important;
          &::after {
            content: '%';
            font-size: 10px;
          }
        }
        &-100 {
          ::v-deep .el-progress__text {
            font-size: 14px !important;
          }
        }
        &-left {
          .small-list {
            display: flex;
            margin-top: 12px;
            min-height: 20px;
            .paper_message {
              display: flex;
              color: #b5b5be;
              font-weight: 400;
              font-size: 14px;
              align-items: center;
              .line {
                width: 1px;
                min-height: 12px;
                border-left: 1px solid #e7e7ed;
                margin: 0 8px;
              }
            }
            .small-item {
              display: flex;
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #515571;
              margin-right: 10px;
              .icon {
                width: 20px;
                height: 20px;
                margin-right: 10px;
              }
            }
          }
        }
        .score-green {
          ::v-deep .el-progress__text {
            color: #62c1a5;
          }
        }
        .score-red {
          ::v-deep .el-progress__text {
            color: #ff858c;
          }
        }
        .mark_img {
          background-image: url(~@/assets/images/un_marked.png);
          width: 44px;
          height: 44px;
          border-radius: 50%;
          color: #696974;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 14px;
        }
      }
      &-bottom {
        display: flex;
        justify-content: space-between;
        padding: 12px 20px;
        border-top: 1px solid #efeff1;
        .diamond {
          display: flex;
          align-items: center;
          color: #1187c9;
          height: 24px;
          min-width: 57px;
          background: #fafafb;
          border-radius: 4px;
          padding: 4px 8px;
          justify-content: space-between;
          .icon {
            width: 20px;
            height: 20px;
          }
        }
        .paper-status {
          display: flex;
          .button {
            min-width: 72px;
            height: 24px;
            background: #faae56;
            border-radius: 4px;
            color: #ffffff;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2px 8px;
            &-yellow {
              background: #faae56;
              color: #ffffff;
            }
            &-blue {
              background: rgba(98, 193, 165, 1);
              color: #fff;
            }
            &-status {
              min-width: 44px;
              margin-right: 12px;
              padding: 2px 8px;
            }
            &-code {
              min-width: 80px;
              margin-right: 12px;
              padding: 2px 8px;
              border-radius: 4px;
              border: 0.5px solid #b5b5be;
              background: #515571;
              color: #fff;
              text-align: center;
              font-family: Inter;
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
            }
          }
          .compact_button {
            height: 32px;
          }
          .yellow {
            background: #faae56;
            color: #ffffff;
          }
          .gray {
            background: #efeff1;
            color: #515571;
          }
          .disable {
            cursor: not-allowed;
            opacity: 0.6;
            background: #909399;
          }
          .start-time {
            cursor: default;
            line-height: 24px;
            margin-left: 5px;
          }
        }
      }
    }

    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 0 auto;
      justify-content: center;
      row-gap: 16px;

      .paper-item {
        width: 100%;
        margin-right: 0 !important;
        margin-bottom: 0 !important;
      }
    }
  }
  .paper-introduce {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    .introduce-item {
      display: flex;
      align-items: center;
      &:not(:first-child) {
        margin-left: 60px;
      }

      .box {
        width: 12px;
        height: 12px;
        border-radius: 3px;
        margin-right: 8px;
      }
      .horn-1 {
        background: linear-gradient(135deg, #838399 0%, #838399 50%, #ffffff 50%, #ffffff 100%);
      }
      .horn-0 {
        background: linear-gradient(135deg, #62c1a5 0%, #62c1a5 50%, #ffffff 50%, #ffffff 100%);
      }
      .horn-2 {
        background: linear-gradient(135deg, #fac856 0%, #fac856 50%, #ffffff 50%, #ffffff 100%);
      }
    }
  }
  .page-panel {
    height: auto;
  }
  .dialog-header {
    width: 100%;
    height: 64px;
    background-image: url(~@/assets/images/introduce_header_bg.png);
    display: flex;
    align-items: center;
    padding: 20px 24px;
    &-title {
      color: #ffffff;
      font-weight: 600;
      font-size: 17px;
      text-align: center;
    }
  }
  .dialog-body {
    .chart-line {
      width: 100%;
      height: 260px;
    }
    .table-content {
      padding: 24px;
      ::v-deep .el-pagination {
        margin-top: 16px;
        text-align: right;
        .el-pager li {
          width: 20px;
          height: 20px;
          min-width: auto;
          border-radius: 50%;
          margin-top: 5px;
          line-height: 21px;
          &:hover {
            color: #faae56;
          }
          &.active {
            color: #ffffff;
            background-color: #faae56;
          }
        }
      }
      .see_result {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #b5b5be;
        cursor: pointer;
      }
      .header-content {
        line-height: 15px;
        .number {
          font-size: 10px;
          margin-top: 2px;
        }
      }
    }
    .empty-content {
      margin-top: 30px;
    }
  }
  ::v-deep .el-table .el-table__cell {
    padding: 8px 0;
  }
  ::v-deep .el-dialog {
    border-radius: 12px;
    &__header {
      padding: 0;
    }
    &__body {
      padding: 0;
    }
  }
  ::v-deep .dialog-paper-status {
    padding: 16px;
    .paper-name {
      margin-top: 32px;
      color: #2c2f46;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
    }
    .paper-title {
      margin-top: 44px;
      color: #2c2f46;
      font-weight: 400;
      font-size: 16px;
      text-align: center;
    }
    .paper-content {
      text-align: center;
      .diamond-input {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        margin-top: 26px;
        position: relative;
        .diamond {
          position: absolute;
          left: -28px;
        }
        .el-input {
          width: 108px;
          height: 32px;
          .el-input__inner {
            height: 32px;
            color: #1187c9;
            caret-color: #faae56;
          }
        }
      }
      .hidden-paper {
        visibility: hidden;
      }
      .button-tools {
        display: flex;
        justify-content: space-between;
        margin-top: 49px;
        .btn-status {
          width: 192px;
          height: 44px;
          border-radius: 4px;
        }
        button[disabled] {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }
  }
  ::v-deep .pay-body {
    .el-dialog__body {
      padding: 16px;
      img {
        margin-top: 52px;
        animation: toRotate 1s linear infinite;
      }
      .pay-loading {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .pay-tips {
        color: #2c2f46;
        font-weight: 600;
        font-size: 16px;
        margin-top: 24px;
      }
      .button-tools {
        display: flex;
        justify-content: space-between;
        margin-top: 49px;
        .btm-pay {
          width: 192px;
          height: 44px;
          border-radius: 4px;
        }
      }
    }
    .un_pay_tips {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 30px;

      p {
        cursor: pointer;
        margin-left: 5px;
        color: #faae56;
        font-weight: bold;
      }
      .contact-us {
        color: #9141c7;
      }
      .callback-tips {
        color: #2c2f46;
        font-size: 16px;
        font-weight: normal;
        word-break: break-word;
      }
    }
    @keyframes toRotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(-360deg);
      }
    }
  }
  ::v-deep .currency-body {
    padding: 20px 20px 0;
    .content {
      background: rgba(239, 239, 241, 0.45);
      border-radius: 6px;
      padding: 14px;
      .select-tips {
        padding: 0 10px;
        font-size: 17px;
        color: #2c2f46;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;
      }
      .select {
        margin-top: 10px;
        .title {
          color: #2c2f46;
          font-size: 14px;
          padding-right: 10px;
          font-weight: 700;
        }
        .el-select {
          width: 240px;
          border: 0;
          .el-input__inner {
            color: #faae56;
            font-size: 12px;
          }
        }
      }
    }
    .change-currency-tips {
      margin: 20px 0 10px;
      text-align: center;
      font-size: 14px;
      color: rgba(105, 105, 116, 0.85);
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
    }
    .dialog-footer {
      .el-button {
        width: 100%;
      }
    }
  }
}
.hsk-tittle {
  font-size: 40px;
  font-weight: 700;
  line-height: 49px;
  color: #2c2f46;
  text-align: center;
}
.smallSize {
  font-size: 11px !important;
}
.tabs_box {
  width: 1200px;
  min-height: 460px;
  border-radius: 12px;
  border: 1px solid var(--Wohui-BG-2, #efeff1);
  background: var(--Wohui-White, #fff);
  margin-top: 19px;
  padding: 33px 26px;
  .tabs_label_item {
    display: flex;
    align-items: center;
  }
  .tabs_label_text {
    color: #b5b5be;
    font-size: 18px;
    font-weight: 600;
    margin-left: 6px;
  }
  .selected_text {
    color: #696974;
    font-size: 18px;
    font-weight: 600;
    margin-left: 6px;
  }

  @media screen and (max-width: 768px) {
    width: 95%;
    margin: 0 auto;
    padding: 12px;
  }
}
.selected {
  color: red;
}
::v-deep .el-tabs__active-bar {
  width: 119px;
  height: 4px;
  background: #2c2f46;
  border-radius: 8px 8px 0px 0px;
}

::v-deep .el-tabs__header {
  margin: 0 0 31px;
}

::v-deep .el-tabs__nav-scroll {
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
}

.practice-root {
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }

  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 70px);
    // max-width: calc(100% - 60px);
  }
  .el-dialog .el-dialog_body {
    flex: 1;
    overflow: auto;
  }
}
// 价格
.container_price {
  display: flex;
  margin: 16px auto;
  align-items: center;
  justify-content: center;
  &_num {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  &_unit {
    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
  }
  &_discount {
    margin-left: 10px;
    color: #faae56;
    cursor: pointer;
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: center;
  }
}
</style>
